export {default as PlayButtonSvg} from './svg/card/PlayButton.svg';

export {default as TraceWhiteLogo} from './svg/logo/Trace.svg';
export {default as TraceLogo} from './svg/logo/TraceLogo.svg';
